import React from "react";
import "./SampleAadharPopup.scss";
import combineAadhar from "../../../assets/docSampleImages/combineAadharSample.jpg";
import borderLine from "../../../assets/Line 9.svg";
import AadharFront from "../../../assets/docSampleImages/Aadhar-Front-Sample.jpg";
import AadharBack from "../../../assets/docSampleImages/Aadhar-Back-Sample.jpg";
import GuideModal from "../../UI/GuideModal/GuideModal";
export interface IViewSampleAadharPopup {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
  parentClassName?: string;
  style?: any;
}
const SampleAadharPopup = (props: IViewSampleAadharPopup) => {
  const [readMore, setReadMore] = React.useState<boolean>(false);
  const closePopup = () => {
    if (props?.setShowPopup !== undefined) props.setShowPopup(false);
  };
  return (
    <GuideModal
      open={!!props.showPopup}
      onClose={closePopup}
      title="Uploading Aadhaar Card Formats"
      titleId="sample-popup-title"
    >

        {/* Popup Content */}
        {/* {commonUIView()} */}
        <div className="Aadhar-format-1">
          <span>
            <span className="Aadhar-format-1-title">
              Uploading E-Aadhaar Card
            </span>
            {!readMore ? (
              <p className="Aadhar-format-read-more">
                Attach both sides of the E-Aadhaar as a PDF (Max Size: 2MB).{" "}
                <button
                  type="button"
                  className="read-more"
                  onClick={() => {
                    setReadMore(true);
                  }}
                >
                  Read more
                </button>
              </p>
            ) : (
              <p className="Aadhar-format-read-more">
                Attach both sides of the E-Aadhaar as a PDF (Max Size: 2MB).
                Download your E-Aadhaar Card from&nbsp;
                <a
                  className="link"
                  href="https://uidai.gov.in/en"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  uidai.gov.in/en/
                </a>
                &nbsp; website.
              </p>
            )}
          </span>
          <div className="imageSection">
            <img src={combineAadhar} alt="Sample Aadhaar card front and back" />
          </div>
        </div>

        <div className="aadhar-or-section">
          <img src={borderLine} className="img-section" width={140} alt="" aria-hidden="true" />
          <span className="title">OR</span>
          <img src={borderLine} className="img-section" width={140} alt="" aria-hidden="true" />
        </div>

        <div className="Aadhar-format-2">
          <span>
            <span className="Aadhar-format-1-title">
              Uploading physical Aadhaar Card
            </span>
            <p className="Aadhar-format-read-more">
              Attach front & back of your physical Aadhaar card in JPEG or PNG
              (Max Size: 2MB)
            </p>
            <span className="Aadhar-Front-row">
              <div className="image-container">
                <img
                  src={AadharFront}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                 alt="Sample Aadhaar front" />
                <div className="badge">1</div>
              </div>

              <span className="Aadhar-Label">FRONT</span>
            </span>
            <span className="Aadhar-Front-row mt-20">
              <div className="image-container">
                <img
                  src={AadharBack}
                  width={130}
                  height={120}
                  className="aadhar-Front-sample document-image"
                 alt="Sample Aadhaar back" />
                <div className="badge">2</div>
              </div>

              <span className="Aadhar-Label">BACK</span>
            </span>
          </span>
        </div>
    </GuideModal>
  );
};
export default SampleAadharPopup;
